import { Box, Typography } from "@mui/material"
import Image from "../../Image"
import profile from "../../../assets/images/profile.png"
import { useAuth } from "../../../contexts/AuthContext";
import LanguageSwitcher from "../../../locales/LanguageSwitcher";
import SearchButton from "../../Button/SearchButton";
import { useTranslation } from "react-i18next";

const AppMenu = () => {
    const { t } = useTranslation();
    const { auth, logout } = useAuth();

    return (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, }}>
            <LanguageSwitcher />
            <SearchButton
                sx={{
                    color: (theme) => theme.palette.text.save,
                    backgroundColor: (theme) => theme.palette.button.save,
                }}
                title={t('onlineCourses.logout')}
                onClick={() => logout()}
            />
            {/* <Image src={profile} style={{ height: '42px', width: '42px', borderRadius: '50%', backgroundColor: '#CCCCCC' }} /> */}
            {/* <Box sx={{ flexDirection: 'column', display: { xs: "none", md: "flex" } }}>
                <Typography display="flex" alignItems="center" gap={"10px"} fontSize="16px" color="#2AB1BF" fontWeight="500">{auth?.userDetails?.username}</Typography>
                <Typography fontSize="12px" color="#90909A" fontWeight="400">{auth?.userDetails?.role}</Typography>
            </Box> */}
        </Box>
    )
}

export default AppMenu